export default {
      id: "chevron-thin-usage",
      viewBox: "0 0 8.4 15.4",
      url: __webpack_public_path__ + "svg/sprite.svg#chevron-thin",
      toString: function () {
        return this.url;
      }
    }